import I18n from 'I18n';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { SidebarCollapseIcon } from 'foundations-assets/icons/components/SidebarCollapseIcon';
import { SidebarExpandIcon } from 'foundations-assets/icons/components/SidebarExpandIcon';
import { trackInteraction } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const NavigationToggle = ({
  isExpanded,
  toggleVisibility
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    justifyContent: isExpanded ? 'end' : 'center',
    children: /*#__PURE__*/_jsx(IconButton, {
      use: "transparent",
      tooltip: isExpanded ? I18n.text('app.nav.visibilityToggle.collapseLabel') : I18n.text('app.nav.visibilityToggle.expandLabel'),
      placement: "right",
      onClick: () => {
        trackInteraction('sidebar-toggled', {
          expanded: !isExpanded
        });
        toggleVisibility();
      },
      children: isExpanded ? /*#__PURE__*/_jsx(SidebarCollapseIcon, {
        color: "icon-core-default"
      }) : /*#__PURE__*/_jsx(SidebarExpandIcon, {
        color: "icon-core-default"
      })
    })
  });
};